import { render, staticRenderFns } from "./ComingSoonPage.vue?vue&type=template&id=e563c27e&scoped=true"
import script from "./ComingSoonPage.vue?vue&type=script&lang=js"
export * from "./ComingSoonPage.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonPage.vue?vue&type=style&index=0&id=e563c27e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e563c27e",
  null
  
)

export default component.exports